import {GameFlowController} from '../../components/game-flow-controller.js';
import {Localization} from '../../utils/Localization.js';
import {ConfirmationDialogController} from '../panels/confirmation-dialog.js';

export function restartGame() {
    const loc = Localization.instance;
    ConfirmationDialogController.instance.displayDialog(
        loc.get('RestartGameDialog'),
        loc.get('RestartGameDialogAccept'),
        loc.get('RestartGameDialogReject'),
        (accepted) => {
            if (accepted) {
                GameFlowController.instance.restartGame();
            }
        }
    );
    // });
}
